export const tooltipStyle = {
  padding: '0.2rem 2rem',
  boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
  borderRadius: '25px'
};

export const tooltipStylePadded = {
  ...tooltipStyle,
  padding: '1rem'
};
